/**
 * Created by iamso on 09.01.19.
 */

const MenuBarItemView = cc.Node.extend({
    avoidNode: "MenuBarItemView",
    ctor: function (item) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.styles = cleverapps.styles.MenuBarItem;
        this.item = item;

        const itemStyles = this.styles.items && this.styles.items[item.getName()];
        if (itemStyles) {
            this.styles = cleverapps.overrideStyles(this.styles, itemStyles, true);
        }

        this.reset(true);
        this.item.onRemove = this.createListener(this.remove.bind(this));
        this.item.onChangeText = this.createListener(this.onChangeText.bind(this));
        this.item.onShowForce = this.createListener(this.showForce.bind(this));
        this.item.onAttentionOnListener = this.createListener(this.turnOnAttention.bind(this));
        this.item.onAttentionOffListener = this.createListener(this.turnOffAttention.bind(this));
        this.item.onSetAnimationAndHide = this.createListener(this.setAnimationAndHide.bind(this));
        this.item.onUpdatePlusButton = this.createListener(this.updatePlusButton.bind(this));
        this.item.onUpdateSticker = this.createListener(this.updateSticker.bind(this));
        this.item.onFingerOnListener = this.createListener(this.turnOnFinger.bind(this));
        this.item.onFingerOffListener = this.createListener(this.turnOffFinger.bind(this));
        this.item.onUpdateClickable = this.createListener(this.updateClickable.bind(this));

        const targetTypes = this.item.getTargetTypes();
        if (targetTypes) {
            cleverapps.aims.registerTarget(targetTypes, this.getIcon(), {
                controls: this.item.getControlName(),
                animate: function (options) {
                    this.text && this.onChangeText({
                        duration: Math.ceil(options.delta / 1.5) * 0.15,
                        withoutDelta: options.withoutDelta
                    });
                    this.animateIcon(options.delta, options.showSparks !== undefined ? !options.showSparks : options.withoutDelta);
                }.bind(this)
            });
        }

        if (this.item.tooltip) {
            cleverapps.tooltipManager.create(this, {
                text: this.item.tooltip,
                location: cleverapps.UI.Tooltip.LOCATION_BELOW,
                control: `${this.item.getControlName()}Tooltip`
            });
        }
    },

    getIcon: function () {
        return this.icon;
    },

    updatePlusButton: function () {
        if (!!this.item.plusButton === !!this.plusButton) {
            return;
        }

        if (this.item.plusButton) {
            this.addPlusButton();
        } else {
            this.plusButton.removeFromParent();
            delete this.plusButton;
        }
    },

    updateFallSaleIcon: function () {
        if (this.item.getName() !== "GoldItem" || !cleverapps.fallSale) {
            return;
        }

        if (cleverapps.fallSale.isAvailable() && !this.fallSaleIcon) {
            this.fallSaleIcon = new FallSaleIcon(FallSaleIcon.POSITION_MENUBAR);
            this.addChild(this.fallSaleIcon);
        }

        if (!cleverapps.fallSale.isAvailable() && this.fallSaleIcon) {
            this.fallSaleIcon.removeFromParent();
            delete this.fallSaleIcon;
        }
    },

    setAnimationAndHide: function (animationName) {
        if (this.icon instanceof cleverapps.Spine) {
            this.icon.setAnimation(0, animationName, false);
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.8),
            new cc.CallFunc(() => {
                cleverapps.focusManager.hideControlsWhileFocused(this.item.getControlName());
            })
        ));
    },

    reset: function () {
        this.turnOffAttention();
        this.removeAllChildren();

        this.addBg();
        this.addIcon();

        this.setContentSize2(this.styles.bg.width + this.iconRealWidth / 2, this.styles.bg.height);
        this.bg.setAlignment(this.styles.bg.width / 2 + this.iconRealWidth / 2, this.height / 2);

        this.updatePlusButton();
        this.addHelpButton();

        this.addText();
        this.updateClickable();

        SceneDecors.add(this.bg, cleverapps.skins.getSlot("menuBarItem", {
            name: this.item.getName()
        }));

        this.updateFallSaleIcon();

        if (this.item.attention) {
            this.turnOnAttention();
        }

        this.updateSticker(true);
    },

    remove: function () {
        cleverapps.focusManager.removeControl(this.item.getControlName());
        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0.3, 0),
            new cc.RemoveSelf()
        ));
    },

    showForce: function (force) {
        cleverapps.forces.create(this, force, {
            importantNodes: [this]
        });
    },

    onChangeText: function (options) {
        options = options || {};
        const delta = this.text.updateValue(options.duration);
        if (delta && this.isVisible() && !options.withoutDelta) {
            cleverapps.aims.showDelta(delta, this, {
                x: this.bg.width / 2 + this.iconRealWidth / 2,
                y: this.styles.deltaAnimation.dy,
                font: cleverapps.styles.FONTS.MENUBAR_TEXT_DELTA || cleverapps.styles.FONTS.MENUBAR_TEXT
            });
        }
    },

    animateIcon: function (flyingItemsAmount, noShine) {
        if (this.icon) {
            MenuBarItemView.animateIcon(this.icon, flyingItemsAmount);
        }

        if (this.item.sparks && this.icon && !noShine) {
            const sparks = new cleverapps.Spine(bundles.animations_library.jsons.sparks_json);
            sparks.setSkin(this.getSparksColor());
            let animation;
            if (flyingItemsAmount > 1) {
                animation = "multiple";
            } else {
                animation = "single";
            }
            sparks.setAnimation(0, animation, false);
            sparks.setCompleteListenerRemove();
            this.addChild(sparks, 0);
            sparks.setAlignment(this.icon.getPositionX() + this.styles.sparks.x, this.icon.getPositionY() + this.styles.sparks.y);
        }
    },

    getSparksColor: function () {
        const colors = cleverapps.styles.MenuBarItem.sparksColors;
        if (colors) {
            return colors[this.item.name] || colors.default;
        }
        return "yellow";
    },

    addIcon: function () {
        if (this.item.animation) {
            this.icon = new cleverapps.Spine(this.item.animation);
            this.icon.setAnimation(0, "idle", true);
        } else {
            this.icon = new cc.Sprite(typeof this.item.icon === "function" ? this.item.icon() : this.item.icon);
            this.icon.setScale(this.styles.icon.scale);
        }
        this.icon.baseScale = this.icon.getScale();
        this.iconRealWidth = this.styles.icon.fullInsideBg ? 0 : this.icon.getBoundingBox().width;

        this.addChild(this.icon);
        this.icon.setLocalZOrder(1);

        this.icon.setAlignment({
            x: this.iconRealWidth / 2 + this.styles.icon.x,
            y: this.styles.bg.height / 2 + this.styles.icon.y
        });
        if (cleverapps.config.debugMode && this.item.onDebugClick) {
            this.debugClickHandler = cleverapps.UI.onClick(this.icon, this.item.onDebugClick, { interactiveScale: false });
        }
    },

    addBg: function () {
        this.bg = cleverapps.UI.createScale9Sprite(bundles.menubar.frames.menubar_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        this.bg.setContentSize2(this.styles.bg.width, this.styles.bg.height);
        this.addChild(this.bg);
    },

    getTextWidth: function () {
        let helpButtonWidth = 0;

        if (this.item.helpButton) {
            helpButtonWidth = this.styles.helpButton.width;
        }

        return this.width - this.iconRealWidth - this.styles.icon.x - this.styles.bg.padding.right - helpButtonWidth;
    },

    getTextPosition: function () {
        const padding = cc.padding(this.styles.bg.padding);
        return cc.p(this.iconRealWidth + this.styles.icon.x + this.getTextWidth() / 2 + this.styles.text.dx, (this.height - padding.bottom - padding.top) / 2 + padding.bottom);
    },

    addText: function () {
        if (this.text && this.text.parent) {
            this.text.removeFromParent();
        }

        const text = new MenuBarTextView(this.item);

        const padding = cc.padding(this.styles.bg.padding);

        this.addChild(text);
        this.text = text;
        this.text.updateValue();
        this.text.setDimensions(this.getTextWidth(), this.height - padding.bottom - padding.top);
        text.setAlignment(this.getTextPosition());
    },

    updateClickable: function () {
        if (this.item.clickable) {
            this.clickHandler = cleverapps.UI.onClick(this, this.onPressed.bind(this), {
                filter: this.item.canActionNow
            });
            this.hoverHandler = cleverapps.UI.applyHover(this, {
                filter: this.item.canActionNow
            });
        } else if (this.clickHandler) {
            this.clickHandler.remove();
            delete this.clickHandler;
            this.hoverHandler.remove();
            delete this.hoverHandler;
        }
    },

    onPressed: function () {
        cleverapps.effects.fire("ui.button.haptic");
        this.item.action();
    },

    addPlusButton: function () {
        const plusButton = this.plusButton = new cleverapps.UI.Button({
            type: {
                button_png: bundles.menubar.frames.plus_button_png,
                button_on_png: bundles.menubar.frames.plus_button_on_png
            },
            onClicked: this.item.action,
            filter: this.item.canActionNow
        });
        this.addChild(plusButton);
        plusButton.setLocalZOrder(2);

        const baseScale = this.styles.plusButton.scale;
        plusButton.baseScale = baseScale;
        plusButton.setScale(baseScale);

        cleverapps.focusManager.registerControl(`${this.item.getControlName()}.Plus`, this.plusButton.createListener((visible, silent) => {
            if (!this.plusButton) {
                return;
            }

            this.plusButton.stopAllActions();

            const scale = visible ? baseScale : 0;

            if (silent) {
                this.plusButton.setScale(scale);
            } else {
                this.plusButton.runAction(new cc.ScaleTo(0.2, scale));
            }
        }));

        if (cleverapps.focusManager.isControlEnabled(`${this.item.getControlName()}.Plus`)) {
            cleverapps.focusManager.showControlsWhileFocused(`${this.item.getControlName()}.Plus`, true);
        }

        const position = cc.p(this.icon.x + this.iconRealWidth / 2, 0);
        position.x += this.styles.plusButton.offset.x;
        position.y += this.styles.plusButton.offset.y;

        plusButton.setAlignment(position);
    },

    addHelpButton: function () {
        if (!this.item.helpButton) {
            return;
        }

        const helpButton = this.helpButton = new cleverapps.UI.Button({
            type: {
                button_png: bundles.help_button.frames.help_button_png,
                button_on_png: bundles.help_button.frames.help_button_on_png
            },
            onClicked: this.item.action,
            filter: this.item.canActionNow
        });
        this.addChild(helpButton);

        cleverapps.focusManager.registerControl(`${this.item.getControlName()}.HelpButton`, this.createListener((visible) => {
            helpButton.stopAllActions();

            if (visible) {
                helpButton.runAction(new cc.ScaleTo(0.2, 1));
            } else {
                helpButton.runAction(new cc.ScaleTo(0.2, 0));
            }
        }));

        helpButton.setAlignment(this.styles.helpButton);
    },

    turnOnAttention: function () {
        if (this.attention) {
            return;
        }

        const styles = cleverapps.styles.MenuBarItem.attention;

        const attention = this.attention = new Attention();
        attention.setScale(styles.scale);
        attention.setAlignment(styles);
        this.addChild(attention);
    },

    turnOffAttention: function () {
        if (this.attention) {
            this.attention.removeFromParent();
            delete this.attention;
        }
    },

    updateSticker: function (silent) {
        const type = this.item.getSticker();

        if (!this.sticker === !type) {
            if (this.sticker) {
                this.sticker.runAction(new cc.Sequence(
                    new cc.ScaleTo(0.2, this.sticker.scale * 1.4),
                    new cc.ScaleTo(0.2, this.sticker.scale)
                ));
                this.text.runAction(new cc.Sequence(
                    new cc.ScaleTo(0.2, this.text.baseScale * 1.4),
                    new cc.ScaleTo(0.2, this.text.baseScale)
                ));
            }
            return;
        }

        if (this.sticker) {
            if (silent) {
                this.sticker.removeFromParent();
            } else {
                this.sticker.runAction(new cc.Sequence(
                    new cc.FadeOut(0.6),
                    new cc.RemoveSelf()
                ));
            }
            this.sticker = undefined;
        }

        switch (type) {
            case "premium":
                this.showPremiumSticker(silent);
                this.icon.setSpriteFrame(this.item.icon());
                this.updatePlusButton();
                break;
        }
    },

    showPremiumSticker: function (silent) {
        const styles = cleverapps.styles.MenuBarItem.premiumSticker;

        const sticker = this.sticker = new cc.Sprite(bundles.menubar.frames.premium_sticker);
        sticker.setAnchorPoint(0.5, 0.5);
        sticker.setAlignment(styles);
        sticker.setRotation(styles.rotation);
        this.addChild(sticker);

        const text = cleverapps.UI.generateOnlyText(Messages.get("WorkersMenuBarItem.subscription"), cleverapps.styles.FONTS.MENUBAR_PREMIUM_STICKER_TEXT);
        text.setAnchorPoint(0.5, 0.5);
        text.setAlignment(styles.text);
        text.fitTo(sticker.width - styles.text.padding.x * 2);
        sticker.addChild(text);

        sticker.setCascadeOpacityEnabled(true);

        if (!silent) {
            sticker.setOpacity(0);
            sticker.runAction(new cc.FadeIn(0.6));
        }
    },

    turnOnFinger: function () {
        this.finger = FingerView.hintTap(this, {
            delay: 1.6
        });
    },

    turnOffFinger: function () {
        FingerView.remove(this.finger);
        this.finger = undefined;
    }
});

MenuBarItemView.animateIcon = function (icon, flyingItemsAmount) {
    icon.stopAllActions();
    icon.setRotation(0);

    icon.setScale(icon.baseScale);
    for (let index = 0; index < Math.ceil(flyingItemsAmount / 1.5); index++) {
        icon.runAction(new cc.Spawn(
            new cc.Sequence(
                new cc.DelayTime(index * 0.07),
                new cc.ScaleTo(0.06, icon.baseScale * 1.15).easing(cc.easeIn(1)),
                new cc.ScaleTo(0.17, icon.baseScale).easing(cc.easeOut(1))
            ),
            new cc.Sequence(
                new cc.DelayTime(0.07),
                new cc.RotateBy(0.13, 8),
                new cc.RotateBy(0.10, -8)
            )
        ));
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MENUBAR_TEXT: {
        name: "default",
        size: 40
    },

    MENUBAR_PREMIUM_STICKER_TEXT: {
        size: 24,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(0, 0, 0, 130),
            size: 2
        }
    }
});

cleverapps.styles.MenuBarItem = {
    noPlusDx: 14,

    bg: {
        width: 200,
        minWidth: 170,
        height: 91,
        padding: {
            right: 30,
            bottom: 10,
            top: 10
        }
    },

    deltaAnimation: {
        dy: -40
    },

    text: {
        dx: 0
    },

    icon: {
        fullInsideBg: false,
        scale: 1,
        x: -10,
        y: 0
    },

    sparks: {
        x: -3,
        y: 5
    },

    plusButton: {
        scale: 1,
        offset: {
            x: 0,
            y: 0
        }
    },

    attention: {
        scale: 1,
        x: { align: "right", dx: 0 },
        y: { align: "bottom", dy: -17 }
    },

    premiumSticker: {
        x: { align: "center", dx: 90 },
        y: { align: "center", dy: 38 },
        rotation: 7,

        text: {
            x: { align: "center" },
            y: { align: "center", dy: 3 },
            padding: {
                x: 12
            }
        }
    },

    helpButton: {
        width: 50,
        x: { align: "right", dx: 5 },
        y: { align: "center" }
    }
};
